import { FeatureFlags } from 'components/common/types/Features.types';
import { PublisherFeatures } from 'components/common/types/Publisher.types';
import features from 'constants/features';

const localEnvironmentFeatures = features();
const negativeFlags = [FeatureFlags.VISUAL_UNITS];
const knownFlags = new Set(Object.values(FeatureFlags));

const normalizeFeatureKey = (key: string): string => {
  if (knownFlags.has(key as FeatureFlags)) {
    return key;
  }

  try {
    return atob(key);
  } catch {
    return key;
  }
};

export const normalizeFeatureKeys = (publisherFeatures: PublisherFeatures): PublisherFeatures => {
  return Object.entries(publisherFeatures).reduce((acc, [key, value]) => {
    acc[normalizeFeatureKey(key)] = value;
    return acc;
  }, {} as PublisherFeatures);
};

export const mergePublisherAndEnvironmentFeatures = (
  environmentId: string,
  publisherFeatures: PublisherFeatures,
  environmentFeatures = localEnvironmentFeatures,
): PublisherFeatures => {
  const encryptEnvironmentFeatures = Object.keys(environmentFeatures).reduce((acc, key) => {
    acc[key] = environmentId;

    return acc;
  }, {} as PublisherFeatures);

  const addNegativeFlags = negativeFlags.reduce((acc, flag) => {
    if (publisherFeatures[flag]) {
      delete publisherFeatures[flag];
    } else if (environmentFeatures[flag] !== false) {
      acc[flag] = environmentId;
    }

    return acc;
  }, {} as PublisherFeatures);

  Object.keys(encryptEnvironmentFeatures).forEach((key) => {
    if (publisherFeatures[key]) {
      if (environmentFeatures[key] === false) {
        delete publisherFeatures[key];
        delete encryptEnvironmentFeatures[key];
      }
    } else if (environmentFeatures[key] === false) {
      delete encryptEnvironmentFeatures[key];
    }
  });

  return { ...publisherFeatures, ...encryptEnvironmentFeatures, ...addNegativeFlags };
};
